import { render, staticRenderFns } from "./ProductStylesList.vue?vue&type=template&id=60551e4a&scoped=true&"
import script from "./ProductStylesList.vue?vue&type=script&lang=js&"
export * from "./ProductStylesList.vue?vue&type=script&lang=js&"
import style0 from "./ProductStylesList.vue?vue&type=style&index=0&id=60551e4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60551e4a",
  null
  
)

export default component.exports